var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload system-upload-file" },
    [
      _c("div", { staticClass: "form-label" }, [
        _c(
          "span",
          { staticClass: "text-star", staticStyle: { color: "#71110e" } },
          [_vm._v("* ")]
        ),
        _vm._v(_vm._s(_vm.$t("merchantAccount.signature_of_the_beneficiary"))),
      ]),
      _vm.absolutePath !== null && _vm.isImg(_vm.absolutePath)
        ? _c(
            "div",
            [
              _c("img", {
                directives: [{ name: "viewer", rawName: "v-viewer" }],
                staticClass: "content-img reply-content-img mt-12",
                attrs: { src: _vm.absolutePath, alt: "" },
              }),
              !_vm.disabled
                ? _c(
                    "el-link",
                    {
                      staticStyle: { "margin-top": "-24px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.deleteImg },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("components.delete")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "mt-12",
                  attrs: { type: "primary" },
                  on: { click: _vm.showModal },
                },
                [_vm._v(_vm._s(_vm.$t("merchantAccount.click_to_sign")))]
              ),
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          staticStyle: { "text-align": "center" },
          attrs: {
            visible: _vm.dialogVisibleFile,
            "close-on-click-modal": false,
            modal: false,
            width: "800px",
            height: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleFile = $event
            },
            close: function ($event) {
              _vm.dialogVisibleFile = false
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("canvas", {
                ref: "canvas",
                staticStyle: {
                  "margin-top": "-20px",
                  "margin-bottom": "30px",
                  "background-color": "#efefef",
                },
              }),
              _c("br"),
              _c(
                "el-button",
                { staticClass: "clear-btn", on: { click: _vm.clearSignature } },
                [_vm._v(" " + _vm._s(_vm.$t("components.clear")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "clear-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleFile },
                },
                [_vm._v(" " + _vm._s(_vm.$t("components.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }